import { CommonApi } from "../api/CommonApi";


export const deleteUser = async (userId) => {
  try {
    // Make the DELETE request to delete the user
    const data = await CommonApi().deleteUser(userId);

    if (data.success) {
      return { success: true, message: data.message };
    } else {
      return { success: false, message: data.errors };
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    return { success: false, message: "An error occurred while deleting the user" };
  }
};

export const createUserAccess = async (reqData) => {
  try {
    const data = await CommonApi().createUserAccess(reqData);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const updateUser = async (userId, updateData) => {
  try {
    const data = await CommonApi().updateUser(userId, updateData);
    if (data.success) {
      return { success: true, data: data.response };
    }
    else {      
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const removeUserAccess = async (reqData) => {
  try {
    const data = await CommonApi().removeUserAccess(reqData);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getUserById = async (userId) => {
  try {
    const data = await CommonApi().getUserById(userId);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};